
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Libero`,
'deleteKey': `⌦ Cancellare`,
'downKey': `↓ Giù`,
'endKey': `⤓ Fine`,
'enterKey': `Entrare`,
'escapeKey': `⎋ Fuga`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generare un 
          <code>LICENZA 
          </code> file 
        `,
'homeKey': `⤒ Casa`,
'keyCommand': `⌘ Comando/Vinci`,
'keyControl': `Controllo`,
'keyOption': `⌥ Opzione/Alt`,
'keyShift': `⇧ Turno`,
'leftKey': `← Sinistra`,
'pagedownKey': `Pagedown`,
'pageupKey': `Pageup`,
'rightKey': `→ Destra`,
's00065e45db8c0441': `Per maggiori dettagli, vedere Strumenti per sviluppatori`,
's001dd78415a91fa0': `Griglia della barra di scorrimento`,
's002fa7d1054ed082': `Box di confine`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazako`,
's01b56d233c6c5cac': `Sezionamento`,
's01d32b35baa3b676': `Autore`,
's02106cc2ef0e7578': `Nuovo perno...`,
's02ab1ea8e5100fc1': `Contrassegnare la selezione come "override bidirezionale".`,
's0312976fe9da5951': `Pulsante`,
's03608a32f05eded2': `Pinch zoom`,
's036d35e03be98d22': `Profondità matematica`,
's037b1dc850a89273': `Alternare sotto`,
's0396202b716732ec': `Contrassegnare la selezione come colpita da un colpo di spugna`,
's03f49e598ffb11cc': `Polacco`,
's0448f1059fa01720': `Salvate, condividete o stampate il vostro esplorabile. Modificare informazioni come il titolo, la lingua o la licenza.`,
's0458872c43beadef': `Inserire la riga prima di`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Spaziatura tra le parole`,
's05e9759cfd99c48f': `Giustificare`,
's063fa5a0a4903bf4': `Lateralmente, da sinistra a destra`,
's064339c229374050': `Codifica`,
's06634274f19b0572': `Selezione dei pin`,
's06743b24499f0035': `Centro di ancoraggio`,
's07808b0ca6da8fef': `Sito web recintato`,
's07970793b21351fd': `Contenitore di base Ruby`,
's079cf7850d9327f0': `Carattere`,
's07aa10850d9ddcc7': `Forma`,
's07e6118e838b2e23': `Navigazione`,
's0816468df86e4036': `Apre le impostazioni`,
's082869038c117fe5': `Portoghese (Brasile)`,
's086e6c267ade2609': `Saturazione`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Inserire un elenco (non ordinato)`,
's09c3f1d21de14ae1': `Contrassegnare la selezione come sottolineata`,
's0a2d91c6720033e9': `Rifinitura della spaziatura del testo`,
's0a3ddcba94027d95': `Adattamento dell'oggetto`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Inserire una navigazione`,
's0a7db790db1fc45c': `Contrassegnare la selezione come campata`,
's0b1271f50a77dc73': `Scatola dei contenuti`,
's0b24d08ea349b455': `Tutto ciò che si può inserire. All'inizio ci sono elementi non interattivi come elenchi o immagini, poi ci sono elementi interattivi chiamati widget. È possibile trovarne di nuovi facendo clic sulla barra di ricerca.`,
's0bdca49248ba4820': `Scorciatoie`,
's0befccf152b6c0a9': `Orientare dai metadati`,
's0c11e479416c8421': `Inserire la didascalia di una tabella`,
's0c27336067c59611': `Imbottitura a scorrimento`,
's0c4593d81f147042': `Linea di base`,
's0c4b2e98d4ab7f5a': `Comandi dell'app`,
's0c883713b83616a8': `Salvare il documento attivo`,
's0ca5c0460199cba1': `Abbreviazione`,
's0cf10c4f40588f8d': `Tabella Didascalia`,
's0d86afa3c6a1e28b': `Direzione di flessione`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Il documento esplorabile. Qui si può scrivere il testo e fare copia/incolla, modificare, ecc.`,
's0dc452999c129e15': `Abilita la ricarica dal vivo`,
's0de0febab8a4beaf': `Errore nella lettura di questo pacchetto`,
's0e44968489e076a8': `Cinese`,
's0e4862e87c7d53ce': `Contrassegnare la selezione come citazione`,
's0e6ea8870dbddab2': `Comandi del documento`,
's0ee28503778e4c0c': `Ultima linea di base`,
's0ef01c03299bbb83': `Decorazione`,
's0f17f32919661cff': `Mongolo`,
's0f350bc4e538e3ea': `Parole`,
's105a06836c40fcb4': `Impostare i filtri, il colore e la fusione degli elementi selezionati.`,
's106b274b5af798e5': `Frasi`,
's1082e1649793dca9': `Contrassegnare la selezione come termine definito`,
's10f3845975a0351e': `Modifica dei metadati`,
's1125d159f7e64df5': `Display`,
's11326fd2590f4e5e': `Predefinito`,
's1155ec07a221e739': `Barra di scorrimento`,
's1173bf7a3e0b74c9': `Minimo (y)`,
's1177237a3e0e548c': `Minimo (x)`,
's1219d97b49650c05': `Visibilità`,
's123bea44f38abccf': `Inserire l'oggetto`,
's1245e2cb9f20197e': `Allineare`,
's12946ec1b850962c': `Inserire la colonna dopo`,
's1351209ef74ee729': `Estensione di tutte le colonne`,
's13c60cb409e8cb6f': `Allineare il centro`,
's13ebd619c8a06a6d': `Griglia a righe automatiche`,
's13ef8ca26ca8861b': `Elemento di taglio`,
's151bc2eea7a032a4': `-Invariato...`,
's153bc3c3aa39587b': `Testa del tavolo`,
's156647179b21d351': `Inserire un corpo di tabella`,
's158b6ec6b1fffcb2': `Pausa dopo`,
's15d0c0657c1ee08c': `Chiave API`,
's1626a7e10a9f9dcc': `Imposta la famiglia di caratteri della selezione`,
's1637c7d1a30629e2': `Box di confine`,
's1641ab440bf4daa4': `Aggiornare il pacchetto di widget`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avanzato: Mostra i pacchetti con versioni come 0.x.x nel gestore di pacchetti`,
's16b9446e3a70e1f4': `Attributi`,
's16f205466761e583': `Nessun dimensionamento ottico dei caratteri`,
's16f2f1c2c516d307': `Aprire un documento`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licenza`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `Rimuovere il campo`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Creare un pacchetto`,
's18d5c44aae3dc82a': `Online durante la modifica`,
's1988d71ef8060edf': `Inserire una riga di tabella`,
's19abee1277c9bca2': `Samoano`,
's19daf2f26c19543d': `Schema`,
's1a1acc902e6668e0': `Mostra la formattazione avanzata del testo`,
's1a5230a71d9285c1': `Cattura`,
's1aa1cb63ad44bc6f': `Distanza tra le colonne`,
's1af8b67d1c85c811': `Spazio tra`,
's1b4a36fce2456660': `Famiglia di caratteri`,
's1c246045629b0016': `Contrassegnare la selezione come eliminazione`,
's1c3fc313a9184670': `Collegamento pubblico`,
's1c65f5004a07dcfa': `Gaelico scozzese`,
's1c690963f1e2df00': `Aspetto specifico della piattaforma`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Volete una breve visita guidata?`,
's1d19244f549ec535': `Istruzione`,
's1d5c7b28e8b50d6d': `Laurea associata.`,
's1db591f5a54dbfd3': `Scatola dei contenuti`,
's1dbb9f50e16c92a3': `Raggio del bordo`,
's1dfb744260fb3a01': `Isolamento bidirezionale`,
's1e9c2c654732cc5f': `Bielorusso`,
's1eaccbf2d6af8ab5': `Informazioni`,
's1efbfc3937d565bd': `Sfondo`,
's1f2b49c1bca2035d': `Catalano`,
's1f74bdf32b51a5fc': `Immagine di sfondo`,
's1f7698c061c208c9': `Aperto`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Corso`,
's21d61916eb8d137d': `Tabella Corpo`,
's21d723a1dbcd89c8': `Giavanese`,
's21f8a2eaf5a70749': `Inserire un'etichetta`,
's2206c42e5b835e6e': `Contrassegnare la selezione come abbreviazione`,
's22a2348c46a912a0': `Inserire una sezione`,
's233ae776268cd44b': `Affari`,
's236ed7ba747099b0': `Peso del carattere`,
's2492f5fb1b05b45e': `Testo`,
's24949d7adbb5a098': `Cassetta degli attrezzi`,
's252a52330d32b900': `Metadati`,
's2540844a4bc4d9ba': `Richiedere l'attribuzione?`,
's255857544a9d5ec0': `Reset`,
's255c77900f2b5e0f': `Schema di colore`,
's256ab831a48c941c': `Rimuove tutta la formattazione del testo dalla selezione.`,
's2591806d7b222591': `Modifiche di reset`,
's25e1a07e454c2c11': `Griglia`,
's262abbaf1d05f009': `Luce soffusa`,
's266935f2447fcd98': `Oltre la sinistra`,
's268ecd1cef45a9a8': `Sei sicuro?`,
's2692bc028fed91f1': `Blocco Maiuscole`,
's27056379e0acfdb0': `Alleggerire`,
's27076e66c5d483ba': `Allineamento verticale`,
's2712dc5641a33226': `Gli account del registro dei pacchetti sono destinati agli sviluppatori e consentono
          di configurare uno o più registri.`,
's27cc88818cc46ff6': `Stabile`,
's281d957112b10f12': `Modificare direttamente l'HTML del documento`,
's28b6246ce616a548': `Inserire un gruppo di colonne della tabella`,
's29a1c26521879b9f': `Riduzione della scala`,
's29acfd2778e8c377': `Nascondere la formattazione avanzata del testo`,
's29b24c06315e9343': `Inserire un ingresso`,
's29eb103449472e3b': `Inserire un titolo (livello 3)`,
's29ee7434494a0dfe': `Inserire un titolo (livello 2)`,
's29f21c34494d614d': `Inserire un titolo (livello 1)`,
's29fbfc3449557f72': `Inserire un titolo (livello 6)`,
's29ff743449588131': `Inserire un titolo (livello 5)`,
's2a031834495bcdb4': `Inserire un titolo (livello 4)`,
's2a75c946ef4dcab7': `Varie`,
's2b2ae20d26f78ac2': `Blocco`,
's2b8f50c64be440f7': str`Selezionare 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Ordine`,
's2bad2d24def4aa0b': `Interruzione di riga (lingua CJK)`,
's2ceb11be2290bb1b': `Annullamento`,
's2ced8e8fafb499f6': `Eliminare l'elemento`,
's2d986d31f8d67357': `Inserire un set di campi`,
's2d995a37cf5e4995': `Inserire un NoScript`,
's2de969afacdaa7a6': `Forma`,
's2df075aface0dab8': `Condividi`,
's2e192b19ed15fcf6': `Pagina`,
's2e39b99cf23606fa': `Impostare il layout degli elementi selezionati`,
's2e4818861000b13f': `Layout`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Trabocco (y)`,
's2edd6688a65e21f0': `Trabocco (x)`,
's2f0bcdffc92a786b': `Galleggiante a destra`,
's2f2044f2431a32d5': `Intestazione`,
's2f4d4bfbc466d91f': `Albanese`,
's2f8da2cb5f236588': `Il nome del pacchetto. Deve avere uno scope, ad esempio \`@org/pkg\`. `,
's30cce87854901922': `Scuola dell'infanzia`,
's3124653c272f054c': `Colore della regola della colonna`,
's314a4f7685c8e824': `Sempre`,
's31c06e226322f065': `Evitare gli orfani`,
's323dcde72b850272': `Accesso pubblico`,
's32911e52ee8ac745': `Inserire uno slot`,
's337a1e9022a8d19f': `Tabella`,
's33c1450d2822bb0f': `Inserire la didascalia di una figura`,
's33c18d5a4cbffa2a': `Irlandese`,
's33f85f24c0f5f008': `Risparmiare`,
's342b0cabfa672822': `Aiutate l'utente a trovare il vostro widget`,
's3437e0d9899e7ae1': `Inviare dati telemetrici sull'utilizzo di WebWriter.`,
's344ea8f4939cdc98': `Colore`,
's34dcda3b0f9d5a98': `Toggle url`,
's34f724979a124c50': `Imposta il colore di sfondo del testo selezionato`,
's355b21b89ce5d9c5': `Dettagli`,
's35ae5f4e0fa2777b': `Allineamento personalizzato`,
's35aeaff1425bca9e': `WebWriter non supporta supporti di tipo `,
's35c3125c7750681e': `Citazione a blocchi`,
's3643189d1abbb7f4': `Codice`,
's3649bacefe731bf6': `Alterna la casella degli strumenti`,
's365280e16a8ea32d': `Copiare la selezione`,
's366991b9c9287765': `Diritto`,
's36a194e38d653a26': `Annotazione dei dati`,
's36b3cefdcb897f15': `Prospettiva`,
's372fae706048ce41': `Pari pari`,
's377e24af9628c37e': `Elenco ordinato`,
's37a8c35f6581da5f': `Nessun ancoraggio`,
's37fa3b9cd51c2dfd': `Imposta la dimensione dei caratteri della selezione`,
's380d17664bb69531': `Inserire la colonna prima di`,
's3815184eb09f0dcf': `Cursore`,
's382a2aa3984474dd': `Creare`,
's38980f98cb07ceb8': `Salvare il documento attivo come copia`,
's3914cb410fca44d4': `Importazione`,
's3a179f6db2972384': `Posizione del rubino`,
's3a5ca02f282d247e': `Condividi...`,
's3ae67088bbefba98': `Pacchetti`,
's3b0ab4b52326316f': `Luce`,
's3b3ea038c5d3bb06': `Divisione`,
's3bdad99768e11911': `Esplorabile`,
's3cb47df8290fa94c': `Inserire un'opzione`,
's3cf89cb47fdde7e9': `Collegamento`,
's3d09398e555ee5f9': `Opzioni avanzate`,
's3d249bb480032121': `Elenco`,
's3d3efd1e19bdcfb4': `Annotazione data/ora`,
's3d6a732c792ccb9e': `Annotazione in rubino`,
's3d93f9ea0c5a13fa': `Immagine`,
's3d9548e211b958ce': `Saltare le sovrapposizioni`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Bello`,
's3eb6d1e6e79ed7c4': `Nessun documento trovato`,
's3eca5a034978754b': `Cancellare la selezione`,
's3f06e9abb6ebcb79': `Personaggi`,
's3f1e7a3f2b283d3b': `Margine`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Inserire un articolo`,
's3fd83566dd643d10': `Inserire una legenda`,
's3fe72792941c18f9': `Fondo del testo`,
's3ffcdc5db5e7d0c5': `Inverso`,
's40e3826b7f74a3b5': `Pan (destra)`,
's40f07d7859284a44': `Linea di base dominante`,
's4101ada154a1b958': `Centro`,
's410c465a5993f82d': `Opportunità di interruzione di riga`,
's41322d19c928c603': `TIC`,
's417b90913e05bc17': `Anteprima`,
's418f2020fe996832': `Confermare le modifiche`,
's41c724f0698148e9': `Contrassegnare la selezione come scorciatoia da tastiera`,
's41f65a763f8e44ab': `Gruppo di intestazione della tabella`,
's42721130228841b0': `Scatola dei colpi`,
's429bd646f1cf8bc6': `Gli account Grammar LLM consentono di utilizzare l'API Grammar LLM per correggere la grammatica nel testo.`,
's429dd933ba95549b': `Inserire un indirizzo`,
's42e470ef1d707a28': `Autoplay`,
's42ffdab1291fb3de': `Inserire la riga dopo`,
's430831017f3f0499': `Obliquità (y)`,
's430bd5017f42511c': `Obliquità (x)`,
's433ba70286202ceb': `Rompere tutti`,
's441b20a8a50e36b4': `Macedone`,
's445b8acb9206db6e': `Scartare e annullare`,
's446a924922651ea0': `Enfasi del testo`,
's44cdba92713de38e': `Area della griglia`,
's45518abd911471d0': `Croato`,
's456a8d744313852a': `Spazio intorno`,
's4634541f5056a546': `Abcaso`,
's46d4abe6255cb9e1': `Riassegnare la scorciatoia`,
's4730c232e7209c40': `Rifinitura di entrambi`,
's474f0eec369d02a4': `Esempio di uscita`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Contrassegnare la selezione come annotazione di data/ora`,
's47ebf3a8fb3b10c1': `Orientamento`,
's4802bb8eb52fbdeb': `Portale`,
's4802e47fe2e95134': `Opzione`,
's491d2919cd6ec3d9': `Tonalità`,
's497838412cb455f2': `Ombra del testo`,
's4993444bfd3f3e5e': `Crollo`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maschera`,
's49dd67aed00029ef': `Matematica`,
's49e763aed00877a8': `Principale`,
's4a894f57eba1cf1e': `Scorciatoia da tastiera`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Luce dura`,
's4b2c143acf931122': `Altezza della linea`,
's4b58c01e2578f5e4': `Leggenda`,
's4bbff4e008690da1': `Evitare la pagina`,
's4c1535f316305a2a': `Ispezionare la selezione`,
's4c402ff5355fd310': `Comando bidirezionale`,
's4caed5b7a7e5d89b': `Inglese`,
's4cb38675a21b2c98': `Tipo di proprietà non supportato '\${desc.type}' (elaborazione come JSON)`,
's4cc8391f172c0cdf': `Terminare il tour`,
's4d528b416ac8dee2': `Inserire un gruppo di titoli`,
's4d546f6c87128d5b': `Prima lo spazio`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Errore di connessione`,
's4e361bf8eef3759a': `Interruzione di parola`,
's4ea0f21fc2a338a1': `Salire`,
's4eace13b3ed74187': `Commento laterale`,
's4efee5b48a4593cb': `Anello`,
's4f26e7cb7c0a8318': `Disegno vettoriale`,
's4fd2e638aabb0bb3': `WebWriter supporta l'incorporazione di molte fonti diverse. È sufficiente incollare
          un link al contenuto di:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thailandese`,
's5015a8fb33b98872': `Sottile`,
's50489ffb1bde152e': `Inserimento`,
's5068560b8d39663d': `Mappa cliccabile`,
's517acbf1f96324f9': `Peso`,
's523eb9043213ff0d': `Corsivo`,
's52777d434baeed9b': `Inserire un indicatore di avanzamento`,
's52af5d7ac34c2163': `Tabella Riga`,
's52e0bdc3ee304436': `Inserire un misuratore`,
's531056f039febd39': `Inserire una selezione`,
's536695196d0b6dc3': `Faerese`,
's542fcefa0bbaed86': `Aprire o chiudere la casella degli strumenti (solo su schermi stretti, altrimenti la casella degli strumenti è sempre visibile sul lato).`,
's5432ad3c84273229': `Figura`,
's543906d1db8b2283': `Modifica `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Cambogiano`,
's54897f2764b0e4d0': `Installare questo pacchetto di widget`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Contrassegnare la selezione come fortemente importante`,
's55905c735052d295': `Pausa tematica`,
's5590dbf7e425789d': `Etichetta`,
's5623aa2f83b05c76': `Tibetano`,
's564d1648b1ceee9f': `Aggiornato`,
's565cd5ffb0158c46': `Evitare la regione`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Torna indietro`,
's5787c6d5b3b5541a': `Percorso clip`,
's579c69f419b6caef': `Liscio`,
's587ac858dd80f6fa': `Sottoscritto`,
's58bec0ecd4f3ccd4': `Rigoroso`,
's59404f5593c32fdc': `Cernita dei caratteri`,
's5941292bb77281ab': `Norvegese Bokmål`,
's599dcd2472c75c19': `Paragrafo`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Contrassegnare la selezione con un'annotazione di dati`,
's5a356677b61a6b7e': `Moldavo`,
's5b474b5c0ac0c7c4': `Gruppo di colonne della tabella`,
's5b517ac216f9ee62': `Lateralmente`,
's5b8cc9bb61ddce15': `Inserire un paragrafo`,
's5bba2ac2e53bd1fd': `Kirghizistan`,
's5be80ad6b8301710': `Avvio in linea`,
's5c1ecf88259b79f9': `Presentazione`,
's5c2a1a52c0389c30': `Ingegneria`,
's5c63af7695445fcf': `Stile del testo`,
's5d18ca4c3111be6f': `Inserire una testata di tabella`,
's5d87c1e588f48d90': `Pratica`,
's5d929ff1619ac0c9': `Ricerca`,
's5da52af9b083c29a': `Modello`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Accedi`,
's5e2cba97c0d971bd': `Ricarica i pacchetti`,
's5e53415a6d5719ad': `Scienze sociali`,
's5e6a7a0c30d2a270': `Salta le sovrapposizioni (auto)`,
's5e9e8e4d21bafedc': `Produzione alimentare`,
's5ed03bb1f3a15949': `Immagine`,
's5f43af3669b1e098': `Fonte`,
's5feaf7fd7ee567c8': `Parola di rottura`,
's600fd23c9ce971e8': `Stampa il documento attivo`,
's602bbd28dae2c60f': `Avvio autonomo`,
's60ff598dfcf2c773': `Sotto Diritto`,
's61053f0e3ebbd272': `normale`,
's613c6ff83883c04f': `Tabella Colonna`,
's6196153c4b0c1ea0': `Installare`,
's61c017f6d5c303af': `Frisone`,
's61ded17ca3f48c82': `Offset di sottolineatura`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Selezione della copia`,
's624e31cd4f1b89d4': `Scorrimento fluido`,
's626daf42b1ab7df7': `Allinea a sinistra`,
's6280bf993915c57a': `Margine di scorrimento`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Descrizione`,
's63dfc5b1c1c27849': `Yiddish`,
's63e03c70f67ebf9c': `Contesto`,
's63e71d20d1eaca93': `Tedesco`,
's640bc7710d0143ce': `Ripristina l'ultima modifica annullata nel documento attivo.`,
's64dc1fc7e3db45c9': `Creare un nuovo documento`,
's65ac276544ba33cd': `File SVG`,
's66765c420ee578e4': `Spazio in modo uniforme`,
's669b18c6d2d9c95b': `Nessuno`,
's6747dbf4ad6063ba': `Autofinanziamento`,
's6787497df07fa97e': `Può scorrere sopra le fermate`,
's67c2b60a506a09e4': `Ed. secondaria.`,
's680bd4d926cd5a84': `Conservare 3D`,
's6827930ef1aeaf99': `URL di base`,
's684a16f3c711394d': `Oltre la destra`,
's687e27f036a71b32': `Isolare`,
's68b87d7b61052dc3': `Riga della tabella`,
's68e0e3a2bab7ce3e': `Evitare`,
's690da6b432987c6f': `Esegue automaticamente il backup delle modifiche apportate al documento corrente. Le modifiche vengono ripristinate quando WebWriter viene ricaricato.`,
's69311c4e25074fb3': `Scuola superiore`,
's697400b541fbc3cd': `Sotto`,
's6988ab5d47593a26': `Avete la versione più recente di WebWriter.`,
's69a49786a8009f43': `Trova i pacchetti...`,
's69b12144dbb6544d': `Laotiano`,
's69d88ef4b2618980': `Copertina`,
's69fbbdb8ad2a084a': `Scurire`,
's6a31eff1ec4f71ad': `Nascondere la faccia posteriore (3D)`,
's6ac62e1c8c66f3bb': `Supercronaca compatta.`,
's6b585ba37cdb8260': `Ereditare`,
's6b61f8abf89586be': `Ebraico`,
's6bd7a02fdf93e653': `Allineare i contenuti`,
's6cfc66b824ea05ba': `Bordi nitidi`,
's6d02dc19e21eb49c': `In alto`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnamita`,
's6d8b3b8047ed378d': `Modalità di miscelazione`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Inserire uno stile`,
's6e288a119281f4c2': `Rendering del testo`,
's6e4c20c6debcd5ca': `Giustificare in modo personalizzato`,
's6f84199e62584905': `Testo preformattato`,
's6fb3053e7244d326': `Altri campi`,
's70178e04a3b691b6': `Aprire le impostazioni`,
's7031ca562378bde6': `Precisione geometrica`,
's7060970b5ed20a58': `Interattività`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Mostra i pacchetti instabili`,
's71dec51005acc1e4': `Fila densa`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Oggetto`,
's731678e227a20559': `Questo dispositivo`,
's736904f276fbd441': `Scienze naturali`,
's739544d0c858c633': str`Oppure lasciate un messaggio 
          ${0} qui 
        `,
's73cb20c838e761e1': `Selezione del taglio`,
's7417792bbe720149': `Rifare`,
's741fae02b3dd24f3': `Pixelato`,
's743f778233e42a3f': `Inserire una nota a margine`,
's744d993d03f29851': `Schermo`,
's748c0074eff45884': `Manipolazione`,
's74aa0039a87141e2': `Ellissi`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Riempire la scatola`,
's75109f5307578a61': `Benvenuti in WebWriter`,
's75a27f43413e02c5': `Francese`,
's75d83fc3f0cfab40': `Intestazione`,
's762e5704cc84089d': `Impostare altre opzioni di stile degli elementi selezionati`,
's77318393dfdb0775': `Rimuovere la riga`,
's77e594ddcc10c774': `Consentire l'uso commerciale?`,
's782eac2b3e80323d': `Contrassegnare la selezione come enfatizzata`,
's782f286a79cca35d': `Relativo`,
's78673a3539cb1915': `In alto a sinistra`,
's78789724e789221c': `Dimensione`,
's789ff24c8f03f1a4': `Spaziatura delle lettere`,
's7995733bf97c01cc': `Serbo-croato`,
's7a99528e7b64635a': `Occitano`,
's7aaf0c06e69600f1': `Errore con `,
's7ae49e142487766c': `Accesso alla comunità`,
's7af555180b30a947': `Aprire gli strumenti per gli sviluppatori`,
's7b4ba250601b8667': `Inserire un modello`,
's7b560d8693ed8f42': `Montante`,
's7b9994904c4f5b54': `Tajik`,
's7bdf0fd5b014d36c': `Forte importanza`,
's7beb1e77e82363eb': `Annullamento dell'ultima modifica nel documento attivo`,
's7c61118554a0ec36': `Massimo (x)`,
's7c95876637f6a9d7': `Filtro`,
's7cb4e55c59663b1c': `Azienda`,
's7cfe12cd14df9950': `Esci`,
's7d27db3c9639c6dd': `Alternanza`,
's7d8103f6f06f83d6': `Imbottitura`,
's7d864465dddbb50d': `Consentire il ridimensionamento`,
's7de0e28d6c309a4e': `Consentire azioni tattili`,
's7dea785045c3cc74': `Premere una nuova combinazione di tasti...`,
's7e0b179d4d1414eb': `Inserire il link`,
's7e6570f2f1ae320f': `Sintetizzare i caratteri tipografici`,
's7ecb1f29332293e5': `Allineamento di base`,
's7ed13ccddb1bf3c3': `Sovrapposizione`,
's7edbe0b213199995': `Laurea triennale`,
's7ede1c55e35ce9d6': `Simulazione`,
's7f09197a4814079b': `Impostare le opzioni di interattività per gli elementi selezionati`,
's7f326a142e856656': `Stile`,
's7fcb35d23be1e643': `Set di campi`,
's80570196a9ce6d11': `Abilitazione della telemetria`,
's806f84eb0ace116e': `Vedere ciò che è stato selezionato e modificarlo. Copia, taglia, incolla, appunta o modifica il layout. Offre opzioni diverse a seconda della selezione, ad esempio la formattazione del testo.`,
's80a42b81c52d4d8f': `Colore del cardo`,
's80b71fc6f43c5ce1': `Sciolto`,
's812cbda653daaeba': `Questa funzione non è ancora stata implementata`,
's814d528c8af55807': `Voce dell'elenco di definizione`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Continua`,
's8247d32213e35f24': `Inserite un'opzione principale`,
's82665b2ffabc9c0a': `Sito web`,
's828b1ecea8715884': `Pan (sinistra)`,
's833bd0422a7ef95d': `Dimensione della scheda`,
's83420ad7b6a14db5': `Strumenti di sviluppo`,
's83c15613b6f6f3c8': `Solo online`,
's83cd32b685ccc9b7': `Controlli`,
's83f26d02dd7aa681': `Visibile`,
's840fa49e8989c028': `Posizione/Forma`,
's844a76d1843ceb3c': `Ripristino delle impostazioni predefinite`,
's84e4e8ae645b82ac': `In alto a destra (y)`,
's84e9c7f8785ca60b': `Inserire un modulo`,
's8517ae4da104b004': `Gruppo di colonne della tabella`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Licenza Creative Commons OER?`,
's85f9aa6d3ea0e421': `Gruppo di piè di pagina della tabella`,
's864b0e6270e97246': `Contrassegnare la selezione come commento a margine`,
's8670e5ad3bf0dcf8': `Salva con nome`,
's8688d74dd3716d6e': `Scorciatoie da tastiera per i comandi`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Margine di forma`,
's87cefc710b3567fb': `Contenere`,
's88676f992b2965db': `Contenuto delle celle allungate`,
's886897f2fd4edb99': `Nascosto`,
's886c5db2a5579873': `Concetto`,
's888c71e8fcb916d3': `Salvataggio automatico`,
's88a62d29529948fb': `Inserire una tabella`,
's89950d86c8004d4b': `Salto senza sovrapposizioni`,
's89bca7498f20e041': `Clip di sfondo`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pausa prima`,
's8a4ff2bd9c13498c': `Record`,
's8a6585c48ea104e9': `Nascondere le celle vuote`,
's8a9eb438abac7c6a': `Etichette`,
's8b0432eecbd8b034': `Aggiornamento`,
's8b7580c35e2aef87': `In alto a sinistra (y)`,
's8bc4affa761aa8a2': `Inserire un'immagine`,
's8c7f51cb067644c7': `Elenco dati`,
's8d342ecaa9e75b9b': `Relazione`,
's8d797888455f4147': `Spazi per la pausa`,
's8d83386457e91813': `Annullare/ripristinare le modifiche o visualizzare l'anteprima dal punto di vista dell'allievo.`,
's8d8643013a7754d1': `Allineare il testo`,
's8df30fe2a50d3479': `Inserire un'opportunità di interruzione di riga`,
's8e715248c3a78446': `Tagliare la selezione`,
's8f29e48d6b9a1aa8': `Inserire una riga di intestazione della tabella`,
's8f4be9f086eb530f': `Annullamento`,
's8f533296a536965e': `Salva con nome...`,
's8fad58c831ecf017': `Contenitore di testo in rubino`,
's8ffe7abcbed8eb43': `Verticale, da sinistra a destra`,
's90105521fcc40453': `Gli account WebWriter Cloud consentono di archiviare documenti online e di
          condividerli con gli studenti. Aggiungete un account qui e sarà disponibile come posizione
          per salvare, caricare, condividere e aprire i documenti.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Tavolozza dei caratteri`,
's90f7c1cf501ea0a7': `Schivata di colore`,
's91093e0b087911ba': `Posizione di rilievo`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Inserire l'embed`,
's9219acd5bef6269e': `Sotto a sinistra`,
's92548405912d46bf': `Allineamento dello snap di scorrimento (y)`,
's9258280591309342': `Allineamento dello scatto di scorrimento (x)`,
's927d796559f49439': `Origine dello sfondo`,
's92b177e579ef7b97': `Enfasi`,
's92f846b9be2e8e8d': `Contrassegnare la selezione come corsivo`,
's93566b84230af4f5': `Inserire un'immagine`,
's936aa0b239679585': `Inserire un'interruzione tematica (di solito visualizzata come una linea orizzontale)`,
's9370dc6afa716b57': `Confine`,
's93f083e654a45715': `Bretone`,
's94653c76b2d86a04': `Termine definito`,
's9485af2e7cd9418f': `Scuola primaria`,
's94d2eee44b292567': `Attivare le opzioni avanzate`,
's94d61907ee22a8c1': `Coreano`,
's94eb1effbbb6498b': `Tracimazione`,
's951aa3a6439f1271': `Marcatore dell'elenco`,
's9565553d163fc92a': `Scrittura`,
's957787fc6b7ea5c0': `Pan (su)`,
's95c161f68e5180a5': `Ispezionare la selezione`,
's95d56e58f816d211': `Olandese`,
's95d8e41a64635c7c': `Spazio bianco`,
's95de7e1eff6c053e': `Orizzontale, dall'alto verso il basso`,
's960d3a90ac199368': `Retoromano`,
's96532132a29dd542': `Inserire l'audio`,
's96a045dcade75ad0': `Colonna densa`,
's9781a5bb3fcb26a3': `Selezionare prima un'azienda`,
's978522fbc9577a7e': `Somalo`,
's97881699a2b21d5b': `Distanza tra le file`,
's97aa76056a81bd36': `Metriche`,
's986facb3ecc9602c': `Lateralmente, da destra a sinistra`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `File esterno`,
's98977a87d1b93941': `Reimpostare informazioni, stili e script`,
's990d0e0fa2ab00b5': `Galiziano`,
's99229574e5692f19': `Groenlandese`,
's99a990f3841ad283': `File di `,
's99b38e000175cc84': `Barrato`,
's99f110d27e30b289': `Titolo`,
's9ab10fbf4c7a7322': `Posizione della sottolineatura`,
's9abadcc828884d7b': `Area di testo`,
's9b7cd8860c8fc922': str`
          ${0}
          sarà sovrascritto. Ne è sicuro? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Colore di sfondo`,
's9c8df9626d152d5a': `Definizione elenco termini`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Colonna della tabella`,
's9cf68f87b8e6122f': `Azerbaigian`,
's9d167ef77aed79b6': `Strato`,
's9d2d00982edafabb': `Turco`,
's9d430adc5be110e9': `Inversione di riga`,
's9d54829be67943d3': `Interlingua`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Cancellazione`,
's9df571714a1efb44': `È disponibile una versione autosalvata di questo esplorabile. Caricarla?`,
's9e28faa598332e2b': `Inserire il video`,
's9e3dbb678150edd4': `Impostare la famiglia di caratteri`,
's9e40e59654c8ad67': `Colonna`,
's9e85800d3700e31c': `Traccia`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variante di carattere`,
's9f1ecdb3061d9cbc': `Conservare gli spazi`,
's9faf26107ed49fb9': `Inserire una cella di tabella`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `La transizione`,
's9ff3121d30f88d52': `Normale`,
's9ffe1bbe64712bf1': `Tela`,
'sa00df4e39c72d3b4': str`
          ${0} non è supportato 
        `,
'sa013e119fec906fb': `Fila`,
'sa01e7bf33563ef72': `Allegato di sfondo`,
'sa126cf8c627cec1e': `Rendering dell'immagine`,
'sa13f72278add7513': `Sotto il diritto`,
'sa1647e3b36ec08d7': `Combinare la posizione verticale`,
'sa172190ea21f9b1c': `Accedere alle impostazioni, aprire un esplorabile o crearne uno nuovo.`,
'sa1c6c459b9b5115c': `Assoluto`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Modello di griglia`,
'sa30c12014e955946': `Russo`,
'sa30f1981fd1cd441': `Dimensione del carattere`,
'sa311a24c1471a974': `Documento`,
'sa352d168b262aa06': `Inserire un piè di pagina`,
'sa37fee6a52d18063': `Cancellare il documento`,
'sa39c7ac1d37f3bce': `Contrassegnare la selezione come "isolamento bidirezionale".`,
'sa3b4c01623211544': `Forza`,
'sa40fd43756fa8913': `Persiano`,
'sa417644bef21a9aa': `Tema senza nome`,
'sa43800e28be1bdbc': `Colore della decorazione`,
'sa477cb1825dceb3b': `Sudanese`,
'sa492a51a707930fa': `Inserire una citazione a blocchi`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Didascalia in basso`,
'sa50d3c35533f1d99': `Tutti i campi`,
'sa53c5cb03a8fda50': `Appuntate la selezione come snippet nella tavolozza`,
'sa557ae6bee9148a6': `Progressi`,
'sa589e1df65dde0ec': `Imposta le dimensioni, il padding e i margini degli elementi selezionati.`,
'sa5c371b4bb75e590': `A sinistra`,
'sa5c80e623459ffe4': `Inserire un'intestazione`,
'sa5df1bcdba46c3fb': `Figura Didascalia`,
'sa602e3fd3f2d98fd': `Animazione`,
'sa644d580d8a11e60': `Allineamento del rubino`,
'sa645d315510dc09e': `Scegliere il percorso dal disco`,
'sa65d4ad99f1d8c06': `Impostare lo sfondo del testo`,
'sa6607436f60ccc1a': `Estone`,
'sa6f8d27bca557059': `Spostare gli elementi meta/link/style in alto/in basso in questo elemento`,
'sa757645ad842da97': `Conservare le pause`,
'sa75b95980cd80e78': `Editore`,
'sa7698b3d20a6d1ec': `Pergamena`,
'sa778acc33947c7b8': `Terminare il tour`,
'sa78a67272a4a6f95': `Formula matematica`,
'sa79167651dce1e80': `Testo alternativo`,
'sa7af797a46c7d09a': `Piè di pagina della tabella`,
'sa7dbe35b758c138d': `Inserire una tela`,
'sa7dc6b8ef3f595dc': `Inserire una sorgente`,
'sa8279f8211b3950d': `Conservare le pause e gli spazi`,
'sa8b55cab62e439b5': `Rimuovere la colonna`,
'sa8bbe0197d31b423': `Breve descrizione`,
'sa9ff3b762365abe6': `Origine della trasformazione (z)`,
'saa02e3762368ff35': `Origine della trasformazione (y)`,
'saa065776236bfa28': `Origine della trasformazione (x)`,
'saa33768e03c45fc8': `Dimensione del file`,
'saaad98061a20ac39': `Inserire una formula matematica`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternanza su`,
'saaec15c97a9e4245': `Inversione della colonna`,
'sab0c57df694a0a09': `Avvio del trim`,
'sab4d9283896d9422': `Risoluzione istantanea pixel`,
'sab55faae8e165407': `Padding&lt;br&gt; come gap`,
'sab5e7d2a069a2951': `Certificato professionale.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Allineare a destra`,
'sac895c732f350ac5': `Scuro`,
'saced41ddda8b2354': `Base flessibile`,
'sad190f86451081c0': `Nepalese`,
'sad6be321164d08c8': `Matematica compatta`,
'sadd352cc7f6f2307': `A parte`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Svedese`,
'sae1c7f13b7c0c47f': `Inizio`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Inserire un elenco di descrizioni (glossario, elenco di termini)`,
'saf3da7c95cb17260': `Contrassegnare la selezione come apice`,
'saf440a0a592f2835': `Aggiornamento a`,
'saf9e5134ba1a7d30': `Scorrimento a scatto`,
'safc6f203342d09e2': `Alterna l'anteprima del documento attivo`,
'sb0a7e3adf4a125ee': `In alto a destra`,
'sb0a974028c99ca6d': `Consentire gli adattamenti?`,
'sb0d4f0f7993cf085': `Impostare la dimensione dei caratteri`,
'sb0f3327210fe18fc': `Colonne`,
'sb0f93c1c60c0249a': `Base in rubino`,
'sb1494c08c8c720d1': `Impostare il colore del testo`,
'sb19611adbc88f711': `Avanzato: Mostra i comandi di modifica dell'origine, ad esempio per mostrare l'HTML del documento o per aggiungere stili e script personalizzati.`,
'sb206d700d26b14ff': `Sottolineatura`,
'sb233557012dcb328': `Scendere`,
'sb26035b596566abf': `Senza nome`,
'sb2cda80610c8d6ea': `Spazio tutto`,
'sb2dc787b0983ebc6': `Lituano`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centro`,
'sb3ba3276ae93627c': `Inserire un blocco di testo preformattato`,
'sb430f5b4824de0d3': `Scegliere un layout`,
'sb43db07b24da018a': `Amarico`,
'sb45f9fb4dba6e71a': `Non impostato`,
'sb4e003a459464d85': `Curdo`,
'sb4f0310e6787d098': `Uzbeko`,
'sb4f1dffbb6be6302': `Libero`,
'sb51270e19988f9bd': `Regione`,
'sb59d621e3c93cc27': `Bordi di cella condivisi`,
'sb5e9e1776242b028': `Interazioni`,
'sb60bc1250aad44c1': `Campata`,
'sb60dd9d23d31ee66': `Dottorato`,
'sb6103872073d369e': `Inserire i dettagli`,
'sb616811735bfbafd': `Cella della tabella`,
'sb628960829e223bb': `Salta tutte le sovrapposizioni`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Applicare e importare`,
'sb66e2181a7b5738a': `Abilitando la telemetria, l'utente acconsente alla raccolta e alla conservazione dei dati in base alla nostra`,
'sb67e0e7c0869f982': `Differenza`,
'sb68e83cda6c85af8': `Intestazione della tabella`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Spessore della decorazione`,
'sb70c17f7899f9b01': `Latino`,
'sb71941f552f3504d': `Impostare un valore speciale`,
'sb740eab4afd5a710': `Flusso automatico della griglia`,
'sb741b6e0ca589122': `Strato di inversione`,
'sb7fb7568f6883ab8': `Condividere il documento attivo`,
'sb85774dc5d18ff0f': `Confermare`,
'sb85b1e36579852a6': `Email o password non valide`,
'sb884fa76bfc55429': `Arabo`,
'sb8a3d4df7d1c5e6b': `Equilibrio`,
'sb8f610a0e8df91fc': `Luminosità`,
'sb8f855b49234b81b': `Applicare`,
'sb905da066c10182c': `Più scuro`,
'sb940ade1bd81be7e': `Sotto sinistra`,
'sb9e9a7dd45966756': `Contrassegnare la selezione come grassetto`,
'sba509fd8ed61d1d5': `File non salvato`,
'sba64d8954d027206': `Opacità`,
'sba88d90cd6c751b3': `Regola della colonna`,
'sbaf0a7c417e388af': `Salute`,
'sbb15d427ee1aa676': `Tigrino`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtro per fondale`,
'sbb85a407d730e13d': `Inserire una ricerca`,
'sbb86c6c96f598bb8': `Misto`,
'sbba0156f795d8c07': `Modifica della selezione`,
'sbba865d4b437944f': `Attributo`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Disinstallare`,
'sbc5f2a81604baf9b': `Rubrica 6`,
'sbc5f2b81604bb14e': `Rubrica 5`,
'sbc5f2c81604bb301': `Rubrica 4`,
'sbc5f2d81604bb4b4': `Rubrica 3`,
'sbc5f2e81604bb667': `Rubrica 2`,
'sbc6953a36ced943f': `Informativa sulla privacy`,
'sbd181cd54b8402a4': `Modifica della selezione`,
'sbd35ee879d9cf770': `Testo in rubino`,
'sbd40f40cbadd38d5': `Rimuovere questo pacchetto di widget`,
'sbd72dc858de95ce8': `Birmano`,
'sbe3c60c65f129daa': `Scienze umane`,
'sbe4a7c8f231739b3': `o incollare/togliere/prelevare il file`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Inserire un'interruzione di riga`,
'sbf00e1ee999ea94e': `Inserire uno script`,
'sbf519920c2017d67': `Appeso`,
'sbfa01f189a68d3e9': `Crescita flessibile`,
'sbff54e740c4086eb': `Mostra i pacchetti sconosciuti`,
'sbfff51feacf30196': `Sanscrito`,
'sc0ceaa9843510f67': `Turcomanni`,
'sc1611c0558728a2a': `Posizione`,
'sc1a155cc25899250': `Gruppo di righe della tabella`,
'sc1aa1f6051b7102a': `Rumeno`,
'sc1edebeaef92b7bd': `Layout di tabella fisso`,
'sc1fff4f356dfb2fb': `Trasformazione`,
'sc24bda3c061fddf8': `Area cliccabile`,
'sc252a4e091763606': `Inserire un piè di pagina della tabella`,
'sc2536e077514accc': `Scorrimento`,
'sc275dd00036d16cb': `Citazioni personaggio`,
'sc28864200d2a3799': `Copiare il codice QR come immagine`,
'sc2a24a9dd41a9503': `Linea di decorazione`,
'sc2b734cca2fa643b': `Pan (giù)`,
'sc2e2a0dbf03723b7': `Avanzato: Mostra i pacchetti da fonti sconosciute nel gestore dei pacchetti (Attenzione: può essere non sicuro)`,
'sc3998b77d72c2932': `Inserire un sito web (come cornice in linea)`,
'sc3ac225273c8316b': `Generale`,
'sc3cfee84dbbf36ae': `File locale`,
'sc3f09a9b6fa4fbed': `All'interno`,
'sc43767deea72e9f3': `Descrizione Elenco`,
'sc462bbdd36bcba6b': `Box di riferimento`,
'sc4ee3e4ee994dafd': `Ucraino`,
'sc50d09edf9325339': `Dialogo`,
'sc52b67794c06a0d3': `Origine prospettica (y)`,
'sc52e8b794c0913d6': `Origine prospettica (x)`,
'sc53de149fcaad713': `Intercarattere`,
'sc5bcf50d1b578d9f': `Impostazioni delle caratteristiche dei caratteri`,
'sc5cb39478b9b7625': `Contrassegnare la selezione come pedice`,
'sc6415b50ff928294': `Voce dell'elenco`,
'sc650ff15b20fe9d3': `Rotazione (z)`,
'sc6578b15b2154365': `Ruota (x)`,
'sc65aff15b2183e58': `Rotazione (y)`,
'sc6da0f4a7e4d710e': `Sovrascrittura della lingua dei caratteri`,
'sc74e3567875ce255': `Sia il tag del vostro widget che il nome del vostro pacchetto NPM`,
'sc7eb080b96e244df': `Malese`,
'sc8ac7ef92b95df3f': `Muoversi (x)`,
'sc8af536e2084ade0': `Tavolozza`,
'sc8b022f92b992bc2': `Spostamento (y)`,
'sc8b39af92b9c2d81': `Spostamento (z)`,
'sc8d2c7f6c33a2b32': `Impostare lo stile del testo (allineamento, indentazione, spaziatura, ecc.) degli
          elementi selezionati.`,
'sc8fa0e3de389ef1c': `Regolazione della dimensione dei caratteri`,
'sc9474bf7a0668d73': `Sintesi`,
'sc94e314312a8900c': `Ceca`,
'sc980855a000b76ea': `Fondo`,
'sc98b103772de63f4': `Finlandese`,
'sca7cfe2bef51b2a5': `Radice`,
'sca7fed2bef53cb99': `Ruolo`,
'scabe6ecee5e01fd2': `Maltese`,
'scace301a88231cce': `Incorporato`,
'scbc55f622ec078c1': `Visualizza la scatola`,
'scbe537fc38ff4c13': `Griglia colonne automatiche`,
'scc1db59d292cbc4c': `Sezione`,
'scc56b218a2689c42': `Armeno`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Imbottitura Box`,
'scd9cedeb5ece3adb': `Sillabare`,
'scdf536b65be39ec5': ` Creare/importare`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografico`,
'sceecdd0bb404bc17': `Inserire un gruppo di opzioni`,
'scf00d48fd5953a03': `Greco`,
'scf932840a69dbb7c': `Portoghese`,
'scf932a8577057752': `Piè di pagina`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `In basso a destra`,
'sd01178c54f648118': `Colonne di bilancio`,
'sd03bff50f87f82d4': `Carattere sillabato`,
'sd05a155fe09c2866': `Online quando si utilizza`,
'sd0864ea6cb6ef22e': `Comunità`,
'sd10fdbe6caf9a998': `Interruzione di linea`,
'sd121d3b959b7888d': `Ottimizzare la velocità`,
'sd1a78e667a1a139f': `Contrassegnare la selezione come inserimento`,
'sd1cffad290ea5b3b': `Mantenere tutti`,
'sd1f10284eeb17b25': `Figi`,
'sd1f44f1a8bc20e67': `Email`,
'sd1f81984eeb7c0e8': `Riempimento`,
'sd29dc07235eea0f5': `Citazione`,
'sd2addf69477cd4b4': `Pacchetto di importazione`,
'sd2ed26defc646d47': `Filtro per fondale`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Fisso`,
'sd3a288c1094b8a63': `Larghezza della regola della colonna`,
'sd3c65ef5c380c046': `Inserto`,
'sd3dcb76f7b28adb8': `Lettone`,
'sd3eca1e0f4209f6e': `Tagliare tutti`,
'sd3f402df8619ddcd': `Queste informazioni sull'utente vengono aggiunte automaticamente ai nuovi documenti.
          È possibile modificarle per ogni documento nell'editor dei metadati.`,
'sd4368b12645d3c0f': `Inserire un portale`,
'sd452cebf4a0313d1': `Mostra i comandi di modifica della sorgente`,
'sd48cc52117f4d68b': `Italiano`,
'sd52660ee947ca58b': `Inserire una colonna della tabella`,
'sd588d17a1b25c220': `Testo in overflow`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Istruzione superiore.`,
'sd5cf95145e4d89ca': `Disimpegnare questo frammento`,
'sd5fd9d11a92f5b1d': `In basso a sinistra (y)`,
'sd60c9bbc51375635': `Inserire un pulsante`,
'sd66c4767fa3dde28': `Colore d'accento`,
'sd679c8b1bf8cc8a5': `Piccoli capitali`,
'sd7086c4425c53c80': `Famiglia di caratteri`,
'sd837f42ac7cbfb58': `Forma (esterno)`,
'sd88076d2994ee0fb': `Esclusione`,
'sd89a2e529b31ef43': `Inversione di marcia`,
'sd8a345e95668b73b': `Verticale, da destra a sinistra`,
'sd8ce9e57270b030d': `Allungamento dei caratteri`,
'sd8ecf227c7c49331': `Matematico`,
'sd8f923198e0c5c6a': `Fine`,
'sd9c21e5f60d6bdd8': `Danese`,
'sd9ff8e2612e63d50': `Dimensionamento del riquadro del bordo`,
'sda2d76b976502a8d': `Aprire...`,
'sda344aacb837387e': `Posizione nel contenitore`,
'sda5b6fa8b771f996': `Galleggiante a sinistra`,
'sda9254d1f1228e1a': `Ungherese`,
'sdb1595f5c742dfbb': `Ingresso`,
'sdb711380a28fec75': `Inserire un elenco (ordinato)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `In basso a destra (y)`,
'sdc48456f9a27ae02': `Generatore`,
'sdc70d81cf6c28533': `Georgiano`,
'sdd1ff479d04ac140': `Pubblico`,
'sdd2fc8919a9c3111': `Modalità di fusione dello sfondo`,
'sdd35b688281b6dea': `Giapponese`,
'sddc49047f66a64ab': `Nessuna descrizione fornita`,
'sdef34fe08bb28b09': `Cinese (semplificato)`,
'sdf62e305e1594805': `Contrassegnare la selezione con un'annotazione in rubino`,
'sdf946172dfa0328f': `Superscriptum`,
'sdf9bc5d9b7f3e3de': `Allineamento`,
'se036b53f145441cd': `Contenuto misto`,
'se06f459fccdc3ce9': `Allinea l'ultima riga di testo`,
'se0a782a8be8e018b': `Norvegese`,
'se0cda6b80a1bb50f': `Slovacco`,
'se0f67eae944f8f94': `Muto`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Articolo`,
'se1f5bb0386c88f96': `Imposta il colore del testo selezionato`,
'se219da7b1e955c65': `Formattazione chiara`,
'se25e4f2cb77b8be8': `Lingua per l'interfaccia WebWriter e nuovi documenti`,
'se2796c5824ec8916': `Visibilità dei contenuti`,
'se308836a594808b6': `Cingalese`,
'se36c5b1baf5e0660': `Ovunque`,
'se39c065efa467782': `Basco`,
'se3b4c857f91f80d7': `Scorciatoie da tastiera`,
'se47baf2fd16b9d2b': `Modello`,
'se48bd9e6c2a3109d': `Conti`,
'se58467472725ad0c': `Risoluzione dell'immagine`,
'se58f06c2b0583ff7': `Scegliere le coordinate`,
'se5dc1e97fb743ade': `Spaziatura`,
'se619a501d1bfe6a5': `Avvolgimento`,
'se62385ac082368d2': `Contrassegnare la selezione come fonte di citazione`,
'se6297163cac9d276': `Modifica della fonte`,
'se633223a0b88625e': `Posizionamento delle celle`,
'se638417c560cfe5c': `Interrompere l'attività all'interno`,
'se64f418b4e733b6c': `Inserire un'uscita`,
'se6cdad455e2d8c02': `Inserire una divisione`,
'se79c0a3ac70d8fb3': `Rapporto di aspirazione (x)`,
'se79fae3ac710dc36': `Rapporto Asp. (y)`,
'se7fad370d8fb4cec': `Ottimizzare la leggibilità`,
'se8a94b4effa2033e': `Alfabetico`,
'se95d4e55ea186d9a': `Colore della barra di scorrimento`,
'se96d43a515b8451c': `Sloveno`,
'se96fd76ba1b2975a': `Centrale`,
'se9ac05f36b004eb0': `Nascondere il tour introduttivo. Disattivare per visualizzare nuovamente il tour.`,
'se9b1fec72ffd8f48': `Locale`,
'sea24bdcaa2bd2dec': `Scatto obbligatorio`,
'sea52df2b70a5c10d': `Rubino`,
'sea6e7291e27ec53f': `Alterna l'editor dei metadati`,
'sea896ed51ad33287': `Non sono disponibili stili specifici`,
'seaaaeb09e3b4e78b': `Comandi di modifica`,
'seabae79729c4b2ad': `Seleziona l'e-mail`,
'seaecc8267bad6234': `Scuola media`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Evitare la colonna`,
'seb4e52ef5ec7a7dc': `Colori/Effetti`,
'seb8982ae8c3cdcc5': `Indonesiano`,
'sebbced89e0db2894': `Prima linea di base`,
'sec02109a0dd2a6c8': `Colore enfatizzato`,
'sec2557a35b702525': `Variabile`,
'sec2da4aa7a02b925': `Islandese`,
'sec30fbb20f102670': `Inserire il riepilogo`,
'sec8b0b6c729816b6': `Gruppo di testa`,
'seccd05955adb76bc': `Poster`,
'sed17285cd25d6389': `Directory in cui si trova package.json`,
'sed318ec045c5144f': `Oltre`,
'sed713f1b916fb469': `Spaziatura tra i bordi (x)`,
'sed74a31b9172942c': `Spaziatura del bordo (y)`,
'sed86bd0deb2e5372': `Trasformare il testo`,
'see2fcaedf9743ec6': `Posizione`,
'seec6798afe90ffc8': `Stampa`,
'sef00c258bc1ecf1e': `Questo esplorabile presenta modifiche non salvate.`,
'sef23dd271edd4a8b': `In basso a sinistra`,
'sef24caccbd4645ef': `Restringimento flessibile`,
'sef49aec68fd1dc66': `Nome`,
'sef73fe18e351eb35': `Parole chiave`,
'sef75f458d77491af': `Gruppo di opzioni`,
'sefcf950b3cc4fc3b': `Lingua`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Contenuti`,
'sf0cab2483f66aa2e': `Personalizzato`,
'sf0e261e04eda82ff': `Aspetto`,
'sf1045382c1fd9a85': `Colori di stampa esatti`,
'sf14c35392ec7bf10': `Questa funzione non è disponibile in Firefox. È disponibile in Chrome o Edge.`,
'sf14f9d5f9f6ca342': `Più leggero`,
'sf1868dc19e3917bb': `Spagnolo`,
'sf190149f9d8bbb2a': `Modalità di scrittura`,
'sf1e79171c4856543': `Siete sicuri? Questa azione non può essere annullata, tutte le impostazioni saranno
          cancellate e ripristinate.`,
'sf21c1f60c7515f44': `Contrassegnare la selezione come uscita campione`,
'sf21fb4f4b9e8911f': `Larghezza`,
'sf22a3737146ec910': `WebWriter può incorporare SVG direttamente nel documento.`,
'sf2514d5dc78b1654': `Inserire il widget`,
'sf28903d4ca0ddcfc': `Rimuovere questo account`,
'sf2ab37af0abc55ef': `Nascondi tour introduttivo`,
'sf2bdb0b4d7b9c039': `Bengalese`,
'sf2cbb5e519264e67': `Ridimensionare sia in orizzontale che in verticale`,
'sf2d5cbc2fe0ad65a': `Appiccicoso`,
'sf2d96d0eb32cb81f': `Composizione dell'animazione`,
'sf2de3dbe2108637a': `Rendering della forma`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `In linea`,
'sf39736a666dbb038': `Inserire una traccia`,
'sf3c4da68b08a2590': `Malgascio`,
'sf471ec2496f904cc': `Scartare le modifiche`,
'sf4849bc200e279ed': `Didascalia della tabella`,
'sf486ca1fdbe08645': `Inserire una figura`,
'sf4b537d4cbd8f5fd': `Testo in alto`,
'sf4e0e02a5277ef23': `Inserire una textarea`,
'sf4f067d41efd4b83': `Scala (y)`,
'sf4f3cbd41f002b46': `Scala (x)`,
'sf4fa67d41f05a008': `Scala (z)`,
'sf5197db2d5f2926a': `Ruotare`,
'sf52d840949a980d1': str`
          ${0}
          sarà eliminato in modo permanente. Ne è sicuro? 
        `,
'sf55d634dcc743595': `Servizi`,
'sf59c9081d106dd9c': `Contrassegnare la selezione come variabile`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Eliminare un documento`,
'sf65df67a03bebe4b': `Richiesto per questo widget`,
'sf6673729c03ae999': `Azzeramento del WebWriter`,
'sf67571992e7dc88e': `Periodo completo`,
'sf6b4934598f7ed10': `Consentire la selezione`,
'sf6e1665c7022a1f8': `Password`,
'sf79e0d78b56444f1': `Estremità in linea`,
'sf7a5f7a7c80c3082': `Entrambi`,
'sf7c0eba7c822e3d6': `In grassetto`,
'sf86bd4d2982f3b74': `Contrassegnare la selezione come codice`,
'sf8e82313fa411494': `Contrassegnare la selezione come collegamento`,
'sf955eff73fb6b573': `Serbo`,
'sf9929e2d356260c5': `Moltiplicare`,
'sf993bb199fefbe04': `Tutti`,
'sf9ecf969dd4b8164': `Entrambi i bordi`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Accesso privato`,
'sfa59c7777e2a0eeb': `Inserire un elenco di dati`,
'sfaa0a67db5c11f72': `Rientro della prima riga di testo`,
'sfb231a52211b133f': `Nessun testo a capo`,
'sfb68cae41d749423': `Iniziale`,
'sfb9b6edb0ed378c9': `Fonte della citazione`,
'sfbbab09dbe553571': `Inserire un disegno vettoriale (SVG)`,
'sfc00292e778b67e2': `Contatore`,
'sfc63e31ac7c956ed': `Selezionare`,
'sfc815c9078bba30a': `Scaricare il codice QR come immagine`,
'sfcdd8e672c75b713': `Indirizzo`,
'sfcebd18506f1e535': `Flusso`,
'sfd0cde85070d2eb2': `Flessibile`,
'sfd77270c3f54f664': `Uscita`,
'sfdb1e4d90981a535': `Condividi questo documento`,
'sfdeef3dccf409f81': `Questa parola chiave è necessaria per i widget`,
'sfe6e758ad2603c1d': `Master`,
'sfee1c12daf838935': `Bruciatura del colore`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Inserire una finestra di dialogo`,
'sffa395f64ec6ac36': `Bulgaro`,
'sffdadf0a576fd802': `Altezza`,
'spaceKey': `Spazio`,
'tabKey': `Scheda`,
'upKey': `↑ Su`,
'scbf29ce484222325': ``,
    };
  